import React from 'react';

const EyeIcon = ({ isVisible = false, onClick }) => {
  const eyeColor = isVisible ? "#2d3649" : "#9ca3af";
  
  return (
    <button 
      type="button"
      className="eye-icon-button"
      onClick={onClick}
      style={{ 
        background: 'none', 
        border: 'none', 
        padding: 0, 
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'absolute',
        right: '12px',
        top: '50%',
        transform: 'translateY(-50%)',
        zIndex: 2
      }}
    >
      <svg 
        width="20" 
        height="20" 
        viewBox="0 0 24 24" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Eye outline */}
        <path 
          d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" 
          fill="none"
          stroke={eyeColor}
          strokeWidth="1.5"
        />
        {/* Slash line - only visible when password is hidden */}
        {!isVisible && (
          <line 
            x1="3" 
            y1="3" 
            x2="21" 
            y2="21" 
            stroke={eyeColor}
            strokeWidth="2" 
            strokeLinecap="round"
          />
        )}
      </svg>
    </button>
  );
};

export default EyeIcon;
